<template>
    <div>
        <HeaderSection icon="fas fa-user-plus" title="Agregar perfil">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/perfiles')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-form ref="profile-form" :model="form">
            <el-row :gutter="20">

                <el-col :span="6">
                    <el-form-item label="Nombre" 
                        prop="name"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                            <el-input placeholder="Nombre" v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                            size="medium"
                            type="danger"
                            icon="el-icon-arrow-left"
                            @click="$router.push('/administracion/perfiles')">
                        Cancelar
                    </el-button>
                    <el-button
                            type="primary"
                            size="medium"
                            icon="far fa-save"
                             @click="submitForm('profile-form')">
                        Guardar
                    </el-button>
                </el-col>
            </el-row>

        </el-form>

        
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import HeaderSection from '../../../partials/HeaderSection';
   
    export default {
        components: {
            HeaderSection,
        },

        data() {
          return {
            form: {
              name: '',
            },
          }
        },

        computed: {
            ...mapState([
                'route'
            ]),
            
        },

        created() {
        },

        methods: {
            
            showLoading() {
                this.$store.dispatch('loading/spinner',
                    {msg: 'Cargando Datos...', status: true}, {root: true});
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            submitForm(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        let _this = this;

                        _this.showLoading();

                        var newProfile = _this.form;


                        axios.post('/api/profiles', newProfile).then(response => {
                            _this.hideLoading();

                            _this.$notify({
                                type: 'success',
                                title: 'Éxito',
                                message: response.data.message
                            });

                            _this.$router.push('/administracion/perfiles');
                        }).catch(error => {
                            _this.hideLoading();

                            _this.$notify({
                                type: 'error',
                                title: 'Error',
                                message: 'No fue posible registrar el perfil, inténtelo nuevamente.'
                            });
                        });

                    } else {
                        this.hideLoading();

                        this.$notify({
                            title: 'Mensaje',
                            message: 'Por favor complete todos los campos requeridos.',
                            type: 'warning'
                        });
                        return false;
                    }
                });        
            },

        }
    }
</script>

<style>
    
</style>
